
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.75 8.25v1.5a.73.73 0 01-.21.54.73.73 0 01-.54.21H3a.73.73 0 01-.54-.21.73.73 0 01-.21-.54v-1.5a.73.73 0 00-.21-.54.73.73 0 00-.54-.21.73.73 0 00-.54.21.73.73 0 00-.21.54v1.5c.016.64.234 1.172.656 1.594.422.422.953.64 1.594.656h6c.64-.016 1.172-.234 1.594-.656.422-.422.64-.953.656-1.594v-1.5a.73.73 0 00-.21-.54.73.73 0 00-.54-.21.73.73 0 00-.54.21.73.73 0 00-.21.54zM5.46.21l-3 3a.782.782 0 00-.21.54c0 .203.07.383.21.54.157.14.337.21.54.21s.383-.07.54-.21l1.71-1.735V7.5c0 .219.07.398.21.54.142.14.321.21.54.21a.73.73 0 00.54-.21.73.73 0 00.21-.54V2.555l1.71 1.734c.157.14.337.211.54.211s.383-.07.54-.21a.782.782 0 00.21-.54.782.782 0 00-.21-.54l-3-3A.782.782 0 006 0a.782.782 0 00-.54.21z","fill":"#478FFF"}})])
          )
        }
      }
    